import { ActionTree, GetterTree, MutationTree, Module } from 'vuex'
import { RootState } from '@/store/states/RootState'
import { ConfiguratorState } from '../states/ConfiguratorState';

const state: ConfiguratorState = {
    piecesInScene: [],
    pieces: []}

// getters
const getters: GetterTree<ConfiguratorState, RootState> = {
}

// actions
const actions: ActionTree<ConfiguratorState, RootState> = {
    /**
     * Init the store if it's not yet initialized 
     */
    init({ commit }) {
        commit('INIT')
    },
}

/// mutations
const mutations: MutationTree<ConfiguratorState> = {

}

export const configurator: Module<ConfiguratorState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}